module.exports = __webpack_public_path__ + "img/logo.e907f34b.png";